import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/fila`

    return {
        list(queryParms) {
            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
        index(queryParms) {
            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        update(id, params) {
            return repository.patch(`${baseUrl}/${id}`, params)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        answer(id) {
            return repository.patch(`${baseUrl}/${id}/answer`)
        },
        sendBack(id) {
            return repository.patch(`${baseUrl}/${id}/send-back`)
        },
        forward(id, params) {
            return repository.patch(`${baseUrl}/${id}/forward`, params)
        },
        evade(id, params) {
            return repository.patch(`${baseUrl}/${id}/evade`, params)
        },
        getAdditionalEnfermagemData(atendimentoId) {
            return repository.get(`${baseUrl}/enfermagem-data/${atendimentoId}`)
        },
        getImpressoes(atendimentoId, setorTipoId) {
            return repository.get(`${baseUrl}/impressao/${atendimentoId}/${setorTipoId}`)
        },
    }
}